module.exports = __webpack_public_path__ + "img/collection-engagementRingsUsa.158327b.webp";